// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c089","top":"styles_top__1ukT_","left":"styles_left__1jY7v","description":"styles_description__oUeTp"};